export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-ceb526e51c9edfffaf94d58c49628926.woff";